import React from 'react';

const ExposedFiltersAndCategories = () => (
  <div data-testid="exposed-filters-and-categories" />
);

export default ExposedFiltersAndCategories;
